import Tagging from "./Tagging";

export default Tagging;